import { Pagination } from "antd";
import { useTranslation } from "react-i18next";

export const AntPagination = (props) => {
  const { t } = useTranslation();
  if(props?.total === 0) return null;

  return (
    <Pagination
      showSizeChanger={false}
      {...props}
      // hideOnSinglePage
      showTotal={(total, range) =>
        t("PAGINATION_SHOW_TOTAL", {
          start: range[0],
          end: range[1],
          total,
        })
      }
    />
  );
};
